"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumablesApplicationService = void 0;
const operators_1 = require("rxjs/operators");
class ConsumablesApplicationService {
    constructor(repo) {
        this.repo = repo;
    }
    findConsumables(tenantId) {
        return this.repo.getForTenant(tenantId);
    }
    async addConsumable(command) {
        const consumables = await this.findConsumables(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!consumables.mayAddConsumable(command.consumable)) {
            return { status: 'rejected' };
        }
        await this.repo.put(consumables.withConsumableAdded(command.consumable));
        return { status: 'accepted' };
    }
    async changeConsumablePrice(command) {
        const consumables = await this.findConsumables(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (command.price.totalCents < 0 ||
            !consumables.consumableWithNameExists(command.consumableName)) {
            return { status: 'rejected' };
        }
        await this.repo.put(consumables.withChangedPriceForConsumable(command.consumableName, command.price.totalCents));
        return { status: 'accepted' };
    }
    async renameConsumable(command) {
        const consumables = await this.findConsumables(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (consumables.consumableWithNameExists(command.newName)) {
            return { status: 'rejected', reason: 'Consumable with new name exists' };
        }
        if (!consumables.consumableWithNameExists(command.oldName)) {
            return { status: 'rejected', reason: 'Consumable not found' };
        }
        await this.repo.put(consumables.withRenamedConsumable(command.oldName, command.newName));
        return { status: 'accepted' };
    }
    async removeConsumable(command) {
        const consumables = await this.findConsumables(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!consumables.consumableWithNameExists(command.consumableName)) {
            return { status: 'rejected' };
        }
        await this.repo.put(consumables.withConsumableRemoved(command.consumableName));
        return { status: 'accepted' };
    }
}
exports.ConsumablesApplicationService = ConsumablesApplicationService;
//# sourceMappingURL=consumables.application-service.js.map